import { render, staticRenderFns } from "./NewEditPlanejamentoDeAula.vue?vue&type=template&id=3337c556&scoped=true"
import script from "./NewEditPlanejamentoDeAula.vue?vue&type=script&lang=js"
export * from "./NewEditPlanejamentoDeAula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3337c556",
  null
  
)

export default component.exports